import { forwardRef } from 'react';

import {
  type WithChildren,
  type AriaLabelingProps,
} from '@dynatrace/strato-components/core';
import { Flex } from '@dynatrace/strato-components/layouts';

/**
 * @public
 */
export interface MenuItemIconProps extends WithChildren, AriaLabelingProps {}

/**
 * An icon which can be used as a child of an Item.
 * @public
 */
export const ItemIcon = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  MenuItemIconProps
>(
  (
    {
      children,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      'aria-details': ariaDetails,
    },
    forwardedRef,
  ) => {
    return (
      <Flex
        ref={forwardedRef}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        aria-details={ariaDetails}
      >
        {children}
      </Flex>
    );
  },
);

(ItemIcon as typeof ItemIcon & { displayName: string }).displayName =
  'Menu.ItemIcon';
